<template>
  <div class="sidebar-balance">
    <bg-text
      type="label"
      color="grey-normal"
    >
      Seu saldo
    </bg-text>

    <div class="sidebar-balance__row">
      <bg-text
        v-if="canShowBalance"
        type="body-md"
        weight="bold"
        color="grey-semi-dark"
      >
        {{ formattedBalance }}
      </bg-text>

      <bg-button
        v-tooltip="'Enviar saldo'"
        variant="outline"
        size="sm"
        icon="plus"
        type="button"
        aria-label="Enviar saldo"
        @click="openCreateEntryDialog"
      />
    </div>

    <bg-link
      v-if="canShowBalance"
      :to="statementRoute"
      class="sidebar-balance__statement"
    >
      <bg-icon
        name="receipt-long"
        size="md"
        color="blue-semi-dark"
        aria-hidden="true"
      />

      <bg-text
        is="span"
        type="body-sm"
        weight="semi-bold"
        color="blue-semi-dark"
      >
        Ver extrato
      </bg-text>
    </bg-link>
  </div>

  <Teleport to="body">
    <entry-wizard-dialog
      ref="entryWizardDialog"
      :on-change="refreshBalanceAfterEntry"
    />
  </Teleport>
</template>

<script setup>
import { computed, getCurrentInstance, onBeforeUnmount, onMounted, ref } from 'vue';
import { BgButton, BgIcon, BgLink, BgText } from '@transfeeradev/bridge';
import EntryWizardDialog from '@/apps/payments/payments/statement/components/presentational/EntryWizardDialog.vue';
import { usePaymentsBalance } from '@/commons/composables/usePaymentsBalance';

defineOptions({
  name: 'sidebar-balance-container'
});

const instance = getCurrentInstance();
const format = instance?.proxy?.$format;

const entryWizardDialog = ref(null);
const balanceRefreshInterval = ref(null);

const statementRoute = {
  name: 'StatementPage'
};

const { balanceValue, validationAccount, initializeBalance, refreshBalance } = usePaymentsBalance();

const formattedBalance = computed(() => {
  return format.currency(balanceValue.value ?? 0);
});

const canShowBalance = computed(() => {
  return !validationAccount.value;
});

const refreshItems = () => {
  return refreshBalance();
};

const refreshBalanceAfterEntry = () => {
  return refreshItems();
};

const openCreateEntryDialog = () => {
  entryWizardDialog.value?.open();
};

const setListeners = () => {
  balanceRefreshInterval.value = window.setInterval(refreshItems, 60000);

  window.addEventListener('topbar.refresh', refreshItems);
  window.addEventListener('balance.refresh', refreshItems);
};

onMounted(() => {
  setListeners();
  initializeBalance();
});

onBeforeUnmount(() => {
  window.clearInterval(balanceRefreshInterval.value);
  window.removeEventListener('topbar.refresh', refreshItems);
  window.removeEventListener('balance.refresh', refreshItems);
});
</script>

<style scoped>
.sidebar-balance {
  width: 100%;
  padding: var(--bg-padding-lg);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--bg-spacing-x-sm);
  text-align: left;
  box-sizing: border-box;
}

.sidebar-balance__row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sidebar-balance__statement {
  display: inline-flex;
  align-items: center;
  gap: var(--bg-spacing-x-sm);
}
</style>